module.exports = __webpack_public_path__ + "static/media/special_offers.dd8a7fa3.png";